import { Pipe, PipeTransform } from '@angular/core';

import { StatusyWeryfikacjiZgodnosciZOryginalem } from '@interfaces/wnioski/platforma-administratora/enums/statusy-weryfikacji-zgodnosci-zoryginalem.enum';

@Pipe({
  name: 'statusWeryfikacjiZgodnosciZOryginalem',
})
export class StatusWeryfikacjiZgodnosciZOryginalemPipe implements PipeTransform {
  transform(value: number): string {
    const { NieSprawdzono, ZgodnyZOryginalem, NieZgodnyZOryginalem } = StatusyWeryfikacjiZgodnosciZOryginalem;
    switch (value) {
      case NieSprawdzono:
        return 'warning';
      case ZgodnyZOryginalem:
        return 'success';
      case NieZgodnyZOryginalem:
        return 'danger';
      default:
        return 'info';
    }
  }
}
